module.exports = __webpack_public_path__ + "static/img/voc-img-02.bb910d3.png";